import { render, staticRenderFns } from "./expenses-gen.vue?vue&type=template&id=5e28b1aa&scoped=true&"
import script from "./expenses-gen.vue?vue&type=script&lang=js&"
export * from "./expenses-gen.vue?vue&type=script&lang=js&"
import style0 from "./expenses-gen.vue?vue&type=style&index=0&id=5e28b1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e28b1aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VWindow } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCol,VDivider,VRow,VSimpleTable,VWindow})
